import React from "react"
import { Modal } from "reactstrap"
import PropTypes from "prop-types"
import CButton from "../components/Common/CButton"

const ConfirmModal = ({
  isOpen,
  onClose,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  confirmColor = "primary",
  cancelColor = "light",
  size = "md",
  centered = true,
  type = "button",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      backdrop="static"
      size={size}
      centered={centered}
    >
      <div className="modal-header">
        <h5 className="modal-title">{title}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Close"
        />
      </div>
      <div className="modal-body">
        <p>{message}</p>
      </div>
      <div className="modal-footer">
        <CButton.Light text={cancelText} onClick={onClose} />
        <CButton.Primary
          text={confirmText}
          onClick={() => {
            onConfirm()
            onClose()
          }}
        />
      </div>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmColor: PropTypes.string,
  cancelColor: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  centered: PropTypes.bool,
}

export default ConfirmModal
